import React from "react";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { BiCoinStack } from "react-icons/bi";
import { IoLockClosedOutline } from "react-icons/io5";
import { BiLike } from "react-icons/bi";
import img1 from "../../../../assets/img/Services/IAMSecuritySolutions/SSo.png";
import { FaBullseye, FaChartLine, FaMap, FaNetworkWired, FaPlug, FaRocket, FaSync } from "react-icons/fa";

export default function PaymentServices() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
              Single Sign-On (SSO)
            </h1>
            <p className="text-lg text-gray-600">
              Reduce login fatigue and enhance productivity with secure, seamless access to multiple applications using a single set of credentials.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaSync className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Consistent User Experience</h3>
              </div>
              <p className="text-gray-600 text-sm">
                Integrate SSO across web, mobile, and cloud platforms for a consistent user experience.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <IoLockClosedOutline className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Interoperability</h3>
              </div>
              <p className="text-gray-600 text-sm">
                Leverage federated identity protocols like SAML, OAuth, and OpenID Connect for interoperability.
              </p>
            </div>
          </div>
        </div>

        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Single Sign-On (SSO)"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
      </div>
    </div>
  );
}
